module.exports = __webpack_public_path__ + "media/images/product-img-06-cc7dee19aa05f687e7d266d004764cce.jpg";